import { render, staticRenderFns } from "./ContentFeedView.vue?vue&type=template&id=5acd388c&scoped=true&"
import script from "./ContentFeedView.vue?vue&type=script&lang=ts&"
export * from "./ContentFeedView.vue?vue&type=script&lang=ts&"
import style0 from "./ContentFeedView.vue?vue&type=style&index=0&id=5acd388c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5acd388c",
  null
  
)

export default component.exports